import { createFileRoute, redirect } from '@tanstack/react-router'
import { OrderDetailScreen } from '@/features/purchasing-orders/order-detail-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one purchase order. `.index` keeps this a sibling of
 * `orders.$orderId.receive.tsx` under `orders.tsx`'s own Outlet — mirrors
 * `_authenticated/accounting/bills.$billId.index.tsx`.
 */
export const Route = createFileRoute('/_authenticated/purchasing/orders/$orderId/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'purchase_order.view')) {
      throw redirect({ to: '/purchasing/orders' })
    }
  },
  component: PurchaseOrderDetailRoute,
})

function PurchaseOrderDetailRoute() {
  const { orderId } = Route.useParams()

  return <OrderDetailScreen orderId={orderId} />
}
